import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives } from "vue"
import _imports_0 from '@/assets/icon.png'
import _imports_1 from '@/assets/fitting_temp.png'
import _imports_2 from '@/assets/drt_temp.png'
import _imports_3 from '@/assets/sim_temp.png'
import _imports_4 from '@/assets/voice_temp.png'
import _imports_5 from '@/assets/multilingual.png'
import _imports_6 from '@/assets/triangle-right.png'


const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "brand" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }),
  /*#__PURE__*/_createElementVNode("h1", null, "HIOKI EIS tools")
], -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", { src: _imports_2 }, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("img", { src: _imports_3 }, null, -1)
const _hoisted_5 = { class: "footer" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("img", { src: _imports_4 }, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("img", { src: _imports_5 }, null, -1)
const _hoisted_8 = { class: "displayCurrentLocale" }
const _hoisted_9 = { class: "sub-lang-select-menu" }
const _hoisted_10 = {
  key: 0,
  src: _imports_6
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_6,
  style: {"transform":"scale(-1, 1)"}
}, null, -1)

import { ref } from "vue";
    import { I18n, VueI18n} from "vue-i18n";
    import { SUPPORTED_LOCALES, DEFAULT_LOCALE, SET_LOADED_LOCALES, setI18nLanguage, loadLocaleResources} from "@/language/i18n";

    
export default /*#__PURE__*/_defineComponent({
  __name: 'SideMenu',
  setup(__props) {

    const isExpanded = ref(true);
    const langSelecting = ref(false);

    const closeOrExpand = function(){
        isExpanded.value = !isExpanded.value;
    }
    const changeLocale = function(i18nObject:VueI18n, locale:string){
        const i18n = {global: i18nObject} as I18n;
        if(!SUPPORTED_LOCALES.includes(locale)){
            locale = DEFAULT_LOCALE;
        }
        //設定する
        setI18nLanguage(i18n, locale);
        //言語リソース読み込み済みか確認
        if(!SET_LOADED_LOCALES.has(locale)){
            //読み込まれていなかったら読み込んで戻る
            return loadLocaleResources(i18n, locale);
        }else{
            //読み込まれてたらそのままでOK
            return;
        }
    }

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("nav", {
    class: _normalizeClass({expanded: isExpanded.value, folded: !isExpanded.value})
  }, [
    _hoisted_1,
    _createVNode(_component_router_link, {
      to: {name: 'equivalent_circuit_fitting'},
      "exact-active-class": "active"
    }, {
      default: _withCtx(() => [
        _hoisted_2,
        _createElementVNode("span", null, _toDisplayString(_ctx.$t("sidemenu.equivalent_circuit_fitting.title")), 1)
      ]),
      _: 1
    }),
    _createVNode(_component_router_link, {
      to: {name: 'distribution_of_relaxation_times'},
      "exact-active-class": "active"
    }, {
      default: _withCtx(() => [
        _hoisted_3,
        _createElementVNode("span", null, _toDisplayString(_ctx.$t("sidemenu.distribution_of_relaxation_times.title")), 1)
      ]),
      _: 1
    }),
    _createVNode(_component_router_link, {
      to: {name: 'impedance_spectra_simulation'},
      "exact-active-class": "active"
    }, {
      default: _withCtx(() => [
        _hoisted_4,
        _createElementVNode("span", null, _toDisplayString(_ctx.$t("sidemenu.impedance_spectra_simulation.title")), 1)
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_router_link, {
        to: {name: 'tell_request'},
        "exact-active-class": "active"
      }, {
        default: _withCtx(() => [
          _hoisted_6,
          _createElementVNode("span", null, _toDisplayString(_ctx.$t("sidemenu.tell_request.title")), 1)
        ]),
        _: 1
      }),
      _createElementVNode("a", {
        onClick: _cache[2] || (_cache[2] = ($event: any) => (langSelecting.value = !langSelecting.value))
      }, [
        _hoisted_7,
        _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.$i18n.locale), 1),
        (isExpanded.value)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createTextVNode(_toDisplayString(_ctx.$t("sidemenu.language")), 1)
            ], 64))
          : _createCommentVNode("", true),
        _withDirectives(_createElementVNode("div", _hoisted_9, [
          _createElementVNode("a", {
            class: _normalizeClass({active: _ctx.$i18n.locale==='en'}),
            onClick: _cache[0] || (_cache[0] = ($event: any) => (changeLocale(_ctx.$i18n as VueI18n, 'en')))
          }, "English", 2),
          _createElementVNode("a", {
            class: _normalizeClass({active: _ctx.$i18n.locale==='ja'}),
            onClick: _cache[1] || (_cache[1] = ($event: any) => (changeLocale(_ctx.$i18n as VueI18n, 'ja')))
          }, "日本語", 2)
        ], 512), [
          [_vShow, langSelecting.value]
        ])
      ]),
      _createElementVNode("a", {
        onClick: closeOrExpand,
        style: {"border-top":"1px solid rgb(200,200,200)"}
      }, [
        (!isExpanded.value)
          ? (_openBlock(), _createElementBlock("img", _hoisted_10))
          : _createCommentVNode("", true),
        (isExpanded.value)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _hoisted_11,
              _createTextVNode(" " + _toDisplayString(_ctx.$t("sidemenu.fold")), 1)
            ], 64))
          : _createCommentVNode("", true)
      ])
    ])
  ], 2))
}
}

})